import { render } from "./RollDefence.vue?vue&type=template&id=9c38373c&ts=true"
import script from "./RollDefence.vue?vue&type=script&lang=ts"
export * from "./RollDefence.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__